import api from '../NetworkService';

const CLIENT_DETAILS_BASE_URL = '/api/user-profile/me';

export const newFormData = () => new FormData();

export const saveUserProfile = (name, photo, createFormData = newFormData) => {
    const userProfile = createFormData();
    userProfile.append('full_name', name);
    userProfile.append('userlogo', photo);

    return api
        .getClient()
        .patch(CLIENT_DETAILS_BASE_URL, userProfile, {
            headers: {
                'Content-Type': `multipart/form-data boundary=${userProfile._boundary}`, // eslint-disable-line no-underscore-dangle
            },
        })
        .then(response => response.data);
};

export const saveUserSettings = userProfile => api
    .getClient()
    .patch(CLIENT_DETAILS_BASE_URL, userProfile)
    .then(response => response.data);
